<div *ngFor="let alert of alertList; last as last"
     [ngClass.mb-3]="!last">

  <mbs-custom-profile-notification-utility [notificationType]="alert"
                                           [includeConnectWise]="includeConnectWise"
                                           [postActions]="postActions"
                                           (onPostActionChanged)="onPostActionChanged($event)">
  </mbs-custom-profile-notification-utility>
</div>
